'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import posthog from 'posthog-js';
import type { TrackingIdKey } from '@/utils/adAttribution';

const URL_KEYS: TrackingIdKey[] = ['gclid', 'gbraid', 'wbraid', 'fbclid'];

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const re = new RegExp('(?:^|; )' + name + '=([^;]*)');
  const match = document.cookie.match(re);
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function AdAttributionRefresher() {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!posthog.__loaded) return;

    const now = new Date().toISOString();
    const lastTouch: Record<string, string> = {};
    const firstTouch: Record<string, string> = {};

    for (const id of URL_KEYS) {
      const value = searchParams.get(id);
      if (!value) continue;
      lastTouch[id] = value;
      lastTouch[`${id}_at`] = now;
      firstTouch[`${id}_first_touch`] = value;
      firstTouch[`${id}_first_touch_at`] = now;
    }

    const fbc = readCookie('_fbc');
    const fbp = readCookie('_fbp');
    if (fbc) {
      lastTouch.fbc = fbc;
      lastTouch.fbc_at = now;
      firstTouch.fbc_first_touch = fbc;
      firstTouch.fbc_first_touch_at = now;
    }
    if (fbp) {
      lastTouch.fbp = fbp;
      lastTouch.fbp_at = now;
      firstTouch.fbp_first_touch = fbp;
      firstTouch.fbp_first_touch_at = now;
    }

    if (Object.keys(lastTouch).length) posthog.register(lastTouch);
    if (Object.keys(firstTouch).length) posthog.register_once(firstTouch);
  }, [searchParams, pathname]);

  return null;
}
